import { render, staticRenderFns } from "./loadingTip.vue?vue&type=template&id=24dda674&scoped=true&"
import script from "./loadingTip.vue?vue&type=script&lang=js&"
export * from "./loadingTip.vue?vue&type=script&lang=js&"
import style0 from "./loadingTip.vue?vue&type=style&index=0&id=24dda674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dda674",
  null
  
)

export default component.exports